/**
 * Class to declare constants pertaining to the Analytics Trends Widget
 */
export class AnalyticsTrendsConstants {
    // Note: This was traditionally associated with the config consumer, but this pattern is muddied with the re-use scenario across widgets.
    public static readonly featureName: string = "AnalyticsTrendsWidget";
};